import { User } from 'firebase/auth';

export async function registerPush(user: User) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      const vapidPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
      if (!vapidPublicKey) {
        console.warn('[Push Notification] VAPID public key (VITE_VAPID_PUBLIC_KEY) is missing. If this is a deployed site, ensure the variable is set in the Cloudflare Pages dashboard.');
        return;
      }

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidPublicKey
      });
    }

    // Send subscription to backend
    const token = await user.getIdToken();
    await fetch('/api/user/push-subscriptions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include',
      body: JSON.stringify({
        ...subscription.toJSON(),
        userId: user.uid
      })
    });
    console.log('Web Push registered successfully');
  } catch (error) {
    console.error('Push registration failed:', error);
  }
}
